// SPDX-License-Identifier: AGPL-3.0-or-later

import Channels from '@app/features/channel/state/Channels';
import Permission from '@app/features/permissions/state/Permission';
import type {
	ChannelSettingsTab,
	ChannelSettingsTabType,
} from '@app/features/user/components/settings_utils/ChannelSettingsConstants';
import {getChannelSettingsTabs} from '@app/features/user/components/settings_utils/ChannelSettingsConstants';
import {ChannelTypes} from '@app/vendor/constants/ChannelConstants';
import type {I18n} from '@lingui/core';
export interface ChannelSettingsModalProps {
	channelId: string;
	initialMobileTab?: ChannelSettingsTabType;
}
export function getAvailableTabs(i18n: I18n, channelId: string): Array<ChannelSettingsTab> {
	const channel = Channels.getChannel(channelId);
	if (!channel) return getChannelSettingsTabs(i18n);
	let filteredTabs = getChannelSettingsTabs(i18n);
	if (channel.type === ChannelTypes.GUILD_CATEGORY) {
		filteredTabs = filteredTabs.filter((tab) => tab.type === 'overview' || tab.type === 'permissions');
	}
	if (channel.type === ChannelTypes.GUILD_VOICE) {
		filteredTabs = filteredTabs.filter((tab) => tab.type !== 'webhooks');
	}
	if (channel.type === ChannelTypes.GUILD_LINK) {
		filteredTabs = filteredTabs.filter((tab) => tab.type !== 'webhooks');
	}
	return filteredTabs.filter((tab) => {
		if (tab.permission && !Permission.can(tab.permission, {guildId: channel.guildId})) {
			return false;
		}
		return true;
	});
}
export function getGroupedSettingsTabs(availableTabs: Array<ChannelSettingsTab>) {
	return availableTabs.reduce(
		(acc: Record<string, Array<ChannelSettingsTab>>, tab: ChannelSettingsTab) => {
			if (!acc[tab.category]) {
				acc[tab.category] = [];
			}
			acc[tab.category].push(tab);
			return acc;
		},
		{} as Record<string, Array<ChannelSettingsTab>>,
	);
}
